import { render, staticRenderFns } from "./refining.vue?vue&type=template&id=0804beb7&scoped=true"
import script from "./refining.vue?vue&type=script&lang=js"
export * from "./refining.vue?vue&type=script&lang=js"
import style0 from "./refining.vue?vue&type=style&index=0&id=0804beb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0804beb7",
  null
  
)

export default component.exports